import {
    fromJS
} from 'immutable';
import * as constants from './constants';
import userRequest, {
    userApi
} from 'common/request';
import { Toast } from 'antd-mobile';
const failToast = (msg) =>{
    Toast.fail(msg, 2);
}
 
export const changeCourseProjectData = (data,totalPage) => ({
    type: constants.CHANGE_COURSE_PROJECT_DATA,
    data: fromJS(data),
    totalPage:fromJS(totalPage)
});
export const changeCourseLiveData = (data,totalPage) => ({
    type: constants.CHANGE_COURSE_LIVE_DATA,
    data: fromJS(data),
    totalPage:fromJS(totalPage)
});
export const changeCourseExperimentData = (data,totalPage) => ({
    type: constants.CHANGE_COURSE_EXPERIMENT_DATA,
    data: fromJS(data),
    totalPage:fromJS(totalPage)
});
export const clearList = (types) => ({
    type: constants.CLEAR_NEW_LISTS,
    types
});

//CHANGE_SEARCH_DATA
export const changeNewLists = (newList) => ({
    type: constants.CHANGE_NEW_LISTS,
    newList: fromJS(newList)
});
export const changeNewProjectLists = (newProjectList) => ({
    type: constants.CHANGE_NEW_PROJECT_LISTS,
    newProjectList: fromJS(newProjectList)
});
export const changeNewLiveLists = (newLiveList) => ({
    type: constants.CHANGE_NEW_LIVE_LISTS,
    newLiveList: fromJS(newLiveList)
});  
export const changeNewExperLists = (newExperList) => ({
    type: constants.CHANGE_NEW_EXPER_LISTS,
    newExperList: fromJS(newExperList)
}); 
export const changePageSize = (page,types) => ({
    type: constants.CHANGE_PAGE_SIZE,
    page: fromJS(page),
    types:fromJS(types)
});

 
//搜索标题
export const changeSearchTitle = (searchTitle) => ({
    type: constants.CHANGE_SEARCH_TITLE,
    searchTitle : fromJS(searchTitle),
});
//搜索分类id
export const changeCateId = (searchCateId) => ({
    type: constants.CHANGE_CATEGORY_ID,
    searchCateId: fromJS(searchCateId),
    
});
export const clearSearchData = () => ({
    type: constants.CLEAR_SEARCH_DATA,
    searchTitle:'',
    searchCateId:'',
});
const categoryData = (categoryList) => ({
    type: constants.CHANGE_CATEGORY_LIST,
    categoryList 
});
 
export const getCategoryData = () => {
    return (dispatch) => {
         userRequest.get(window.AppConfig.mainIP + userApi.courseCategory,{
            tenant: localStorage.getItem('tenant_code'),
         }).then((res) => {
            let result = ''
            if(res.code===0){
                result = res.data;
                dispatch(categoryData(result))
            }else{
                failToast(res.msg)
            }
     });
    }
}

export const getCourseList = (types, page, perpage,title,cate,sort) => {
    return (dispatch) => {
        userRequest.get(window.AppConfig.mainIP + userApi.courseList, {
            types: types || '',
            page: page || 1,
            'per-page': perpage || 12,
            tenant: localStorage.getItem('tenant_code'),
            title:title || "",
            cate:cate || '',
            sort:sort||'',
            live_status:'all',
        }).then((res) => {
            if (res.code === 0) {
                if (types === 'live') {
                    let totalPage = Math.ceil(res.data.live.total / 10); 
                    dispatch(changeCourseLiveData(res.data.live,totalPage))
                    dispatch(changeNewLiveLists(res.data.live.models))
                } else if (types === 'project') {
                    let totalPage = Math.ceil(res.data.project.total / 10); 
                    dispatch(changeCourseProjectData(res.data.project,totalPage))
                    dispatch(changeNewProjectLists(res.data.project.models))
                } else if (types === 'experiment') {
                    let totalPage = Math.ceil(res.data.experiment.total / 10);
                    dispatch(changeCourseExperimentData(res.data.experiment,totalPage))
                    dispatch(changeNewExperLists(res.data.experiment.models))
                }
                
               
            }
        })
    }
}